import {useApi} from '../classes/appApi'
import FormModal from '../components/Shared/FormModal'
import {EqxFormInputSelect, EqxFormInputTextarea, EqxFormRow} from '../shared/components/EqxForm/EqxForm'
import {eqxFormStateManager, eqxModalStateManager, useFormState, useModalState} from '../shared/components/EqxFormModal'

interface HelpModalProps {
    name?: string
    form?: eqxFormStateManager
    modal?: eqxModalStateManager
}

const HelpModal = function (props: HelpModalProps) {
    const api = useApi()

    const title = 'Help & Support'
    const action = api.endpoints.sendHelpEmail().url
    const form = useFormState(props.form)
    const modal = useModalState(props.modal)
    const options = [
        {
            value: 'help',
            label: 'Help & Support',
            message: 'Request help with the data on this page',
        },
        {
            value: 'bug',
            label: 'Report a System Error',
            message: 'Report a bug in the app',
        },
        {
            value: 'feedback',
            label: 'Feedback',
            message: 'Provide feedback on an existing feature or suggest a new one',
        },
    ]
    const issue = form.getValue('issue')
    const selectedIssue = !issue ? null : options.find((option) => option.value == issue)
    return (
        <FormModal
            form={form}
            modal={modal}
            action={action}
            title={title}
            prepareData={(data: any) => {
                data.sourceURL = window.location.href
                return data
            }}
        >
            <EqxFormRow name="issue" comment={selectedIssue?.message}>
                <EqxFormInputSelect required={true} name="issue" blankText="Select Issue..." options={options} />
            </EqxFormRow>
            {selectedIssue && (
                <EqxFormRow name="message">
                    <EqxFormInputTextarea required={true} name="message" placeholder="Your Message..." />
                </EqxFormRow>
            )}
        </FormModal>
    )
}
export {HelpModal as default}
